<nb-card>
  <nb-card-header>
    <div class="row justify-content-between">
      <div class="col-auto my-auto">
        <span class="h4" translate="tenant.disabled.title"></span>
      </div>
      @if (canCloseDialog) {
      <div class="col-auto">
        <button
          nbButton
          (click)="dismiss()"
          [nbPopover]="adminDismissDialog"
          nbPopoverTrigger="hint"
          status="basic"
          ghost
          class="float-right"
        >
          <nb-icon icon="close-outline"></nb-icon>
        </button>
      </div>
      }
    </div>
  </nb-card-header>
  <nb-card-body>
    <p translate="tenant.disabled.message"></p>
  </nb-card-body>
  <nb-card-footer>
    <!-- Show logout button -->
    <button
      nbButton
      (click)="logout()"
      status="secondary"
      class="float-right"
      translate="auth.logout"
    ></button>
  </nb-card-footer>
</nb-card>

<ng-template #adminDismissDialog>
  <div
    class="subtitle-2 popover-padding"
    translate="tenant.disabled.adminDismissHint"
  ></div>
</ng-template>
